<template>
  <div style="width: 100%; height: 100%">
    <div v-if="showContract == 1" class="searchResult-wrap">
      <Contract :showContract.sync="showContract"> </Contract>
    </div>
    <div class="owner-message" v-show="showContract == 0">
      <div class="owner-message-content" style="height: 100%">
        <div class="owner-message-back"></div>
        <div class="owner-message-top">
          <div class="top-text">填写房主信息</div>
          <div>
            <div class="top-text">手机号</div>
            <div style="margin-top: 0.1rem">
              <input type="text" placeholder="请输入手机号" v-model="cellPhoneNumber" />
            </div>
          </div>
          <div>
            <div class="top-text">身份证号</div>
            <div style="margin-top: 0.1rem">
              <input type="text" placeholder="请输入身份证号" v-model="idCardNumber" />
            </div>
          </div>
        </div>
        <div class="owner-message-buttom">
          <div>
            <el-button
              style="background: #007b83; color: #fff; border: none; padding: 4%"
              @click="getRoomOwnerInfo"
              >确定</el-button
            >
          </div>
          <div>
            <el-button
              style="
                margin: 0.2rem 0px;
                background: rgba(0, 123, 131, 0.1);
                border: 1px solid rgba(0, 123, 131, 1);
                color: #007b83;
                padding: 4%;
              "
              @click="handleCancelClick"
              >取消</el-button
            >
          </div>
        </div>
      </div>
      <!-- <div class="owner-message-content">
      <div class="owner-message-back"></div>
      <div class="owner-message-top">
        <div>
          填写信息与预留信息不
        </div>
      </div>
    </div> -->
      <div class="mark-hint" v-if="hintFlag">
        <div>
          <div style="text-align: right; padding: 0.1rem 0.15rem; color: #aaaaaa">
            <i class="iconfont iconguanbi" @click="hintFlag = false"></i>
          </div>
          <div style="color: #007b83; margin-top: 0.14rem">
            <div>
              <div style="padding: 0rem 0.3rem">{{ textHint }}</div>
              <div v-if="hintFlag2">请重新检查您的信息~</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Contract from '@/components/contract/contract.vue';
export default {
  components: {
    Contract,
  },
  data() {
    return {
      cellPhoneNumber: '',
      idCardNumber: '',
      textHint: '', // 提示信息
      hintFlag: false,
      hintFlag2: true,
      showContract: null,
    };
  },
  mounted() {
    this.getWxHeatContract();
    document.title = '房主信息';
  },
  methods: {
    // 获取合同
    async getWxHeatContract() {
      const res = await this.$http.get(this.$url.globalurl + '/wxHeatContract');
      console.log(res);
      if (res.result) {
        this.showContract = 0;
      } else {
        this.showContract = 1;
      }
    },
    handleCancelClick() {
      this.$router.replace({
        name: 'index',
      });
    },
    // 获取房屋信息
    async getRoomOwnerInfo() {
      if (!this.cellPhoneNumber || !this.idCardNumber) {
        this.hintFlag = true;
        this.hintFlag2 = false;
        return (this.textHint = '抱歉！请您填写完相关信息后， 再次确认~');
      }
      if (!/^1[3456789]\d{9}$/.test(this.cellPhoneNumber)) {
        this.hintFlag = true;
        this.hintFlag2 = true;
        return (this.textHint = '抱歉，您的电话号码错误');
      }
      if (
        !/^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(
          this.idCardNumber
        )
      ) {
        this.hintFlag = true;
        this.hintFlag2 = true;
        return (this.textHint = '抱歉，您的身份证号码有误');
      }
      const res = await this.$http.post(`${this.$url.globalurl}/wxContinueStop`, {
        phone: this.cellPhoneNumber,
        id_card: this.idCardNumber,
      });
      if (res.code === 200) {
        if (res.result && res.result.length > 0) {
          this.$router.replace({
            name: 'continueStop',
            query: {
              phone: this.cellPhoneNumber,
              id_card: this.idCardNumber,
            },
          });
        } else {
          this.$router.replace({
            name: 'searchHint',
            query: {
              noInfo: true,
            },
          });
        }
      }
    },
  },
};
</script>
<style scoped>
@import url(ownerMessage.scss);
</style>

